/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Article_Read_OriginalInputs */



/**
* | output |
* | --- |
* | "Read the full article on the {source} site" |
*
* @param {Article_Read_OriginalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const article_read_original = /** @type {((inputs: Article_Read_OriginalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Article_Read_OriginalInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`在 ${i?.source} 网站阅读全文`)
	return /** @type {LocalizedString} */ (`Read the full article on the ${i?.source} site`)
});